const widgetCustomSections = document.querySelectorAll('.shopify-section--boost-widget-custom');

widgetCustomSections.forEach((section) => {
  const tabs = section.querySelectorAll('.boost-widget-custom__tab');
  const widgets = section.querySelectorAll('.boost-widget-custom');
  const isStacked = section.querySelector('.boost-widget-custom__container--stacked') !== null;

  if (isStacked) {
    console.log('[Boost Widget] Skipping tab initialization for stacked layout');
    return;
  }

  let currentWidget = null;
  let isTabSwitching = false;
  const prevArrow = section.querySelector('[data-boost-arrow="prev"]');
  const nextArrow = section.querySelector('[data-boost-arrow="next"]');
  const arrowsWrap = section.querySelector('[data-boost-arrows]');

  const updateCarouselArrows = () => {
    if (!arrowsWrap) return;

    const swiper = currentWidget?.swiper;
    const canNavigate = Boolean(swiper && swiper.slides && swiper.slides.length > 1);

    arrowsWrap.hidden = !canNavigate;
    if (!canNavigate) return;

    if (prevArrow) {
      prevArrow.disabled = swiper.isBeginning;
      prevArrow.classList.toggle('is-disabled', swiper.isBeginning);
    }
    if (nextArrow) {
      nextArrow.disabled = swiper.isEnd;
      nextArrow.classList.toggle('is-disabled', swiper.isEnd);
    }
  };

  const bindCarouselArrows = (widget) => {
    if (!widget?.swiper) {
      updateCarouselArrows();
      return;
    }

    widget.swiper.off('slideChange', updateCarouselArrows);
    widget.swiper.off('reachBeginning', updateCarouselArrows);
    widget.swiper.off('reachEnd', updateCarouselArrows);
    widget.swiper.off('fromEdge', updateCarouselArrows);
    widget.swiper.on('slideChange', updateCarouselArrows);
    widget.swiper.on('reachBeginning', updateCarouselArrows);
    widget.swiper.on('reachEnd', updateCarouselArrows);
    widget.swiper.on('fromEdge', updateCarouselArrows);
    updateCarouselArrows();
  };

  if (prevArrow) {
    prevArrow.addEventListener('click', () => {
      currentWidget?.swiper?.slidePrev();
      updateCarouselArrows();
    });
  }

  if (nextArrow) {
    nextArrow.addEventListener('click', () => {
      currentWidget?.swiper?.slideNext();
      updateCarouselArrows();
    });
  }

  section.addEventListener('boost-widget:swiper-ready', (event) => {
    if (event.target === currentWidget) {
      bindCarouselArrows(currentWidget);
    }
  });

  const deactivateAll = () => {
    tabs.forEach((tab) => tab.classList.remove('active'));
  };

  const disableAllTabs = () => {
    tabs.forEach((tab) => tab.disabled = true);
  };

  const enableAllTabs = () => {
    tabs.forEach((tab) => tab.disabled = false);
  };

  const applySectionHeightLock = () => {
    const lockedHeight = section.dataset.boostLockedMinHeight;
    if (!lockedHeight) return;

    section.style.setProperty('--boost-widget-min-height', `${lockedHeight}px`);

    const panel = section.querySelector('.tabs__panel');
    if (panel) {
      panel.style.minHeight = `${lockedHeight}px`;
    }

    const container = section.querySelector('.boost-widget-custom__container');
    if (container) {
      container.style.minHeight = `${lockedHeight}px`;
    }

    widgets.forEach((widget) => {
      widget.style.minHeight = `${lockedHeight}px`;
    });
  };

  const transitionToWidget = async (fromWidget, toWidget) => {
    applySectionHeightLock();

    // Keep reserved height while swapping; show the next widget before fully hiding the current one
    if (toWidget) {
      toWidget.classList.remove('hidden');
      toWidget.style.opacity = '0';
    }

    if (window.FoxTheme && window.FoxTheme.Motion) {
      const animations = [];
      if (fromWidget) {
        animations.push(
          window.FoxTheme.Motion.animate(fromWidget, { opacity: [1, 0] }, { duration: 0.25 }).finished,
        );
      }
      if (toWidget) {
        animations.push(
          window.FoxTheme.Motion.animate(toWidget, { opacity: [0, 1] }, { duration: 0.25 }).finished,
        );
      }
      await Promise.all(animations);
      if (fromWidget) {
        fromWidget.classList.add('hidden');
        fromWidget.style.opacity = '';
      }
      if (toWidget) {
        toWidget.style.opacity = '';
      }
    } else {
      if (fromWidget) {
        fromWidget.style.transition = 'opacity 0.25s ease';
        fromWidget.style.opacity = '0';
      }
      if (toWidget) {
        toWidget.style.transition = 'opacity 0.25s ease';
        void toWidget.offsetHeight;
        toWidget.style.opacity = '1';
      }
      await new Promise((resolve) => setTimeout(resolve, 260));
      if (fromWidget) {
        fromWidget.classList.add('hidden');
        fromWidget.style.opacity = '';
        fromWidget.style.transition = '';
      }
      if (toWidget) {
        toWidget.style.opacity = '';
        toWidget.style.transition = '';
      }
    }

    applySectionHeightLock();
  };

  const activateTab = async (widgetId, blockId) => {
    const widget = section.querySelector(`#boost-custom-widget-${widgetId}`);
    if (!widget || widget === currentWidget) return;

    // Load target content before swapping so the panel does not collapse to empty
    if (typeof widget.onWidgetActivated === 'function') {
      await widget.onWidgetActivated();
    }
    if (typeof widget.applyLockedMinHeight === 'function') {
      widget.applyLockedMinHeight();
    }
    applySectionHeightLock();

    await transitionToWidget(currentWidget, widget);
    currentWidget = widget;

    const hasViewAllButton = currentWidget.dataset.hasViewAllButton === 'true';
    currentWidget.classList.toggle('has-view-all-button', hasViewAllButton);

    const tabContent = currentWidget.querySelector('.boost-widget-custom__tab-content');
    if (tabContent) {
      tabContent.classList.toggle('has-view-all-button', hasViewAllButton);
    }

    bindCarouselArrows(currentWidget);
  };

  const updateWidgetHeader = (widgetId) => {
    const widgetData = getWidgetData(widgetId);
    if (!widgetData) return;

    const sectionHeader = section.querySelector('.section__heading');
    const sectionHeaderWrap = section.querySelector('.section__header');
    const sectionSubheading = section.querySelector('.section__subheading');

    // Get original section heading/subheading from data attributes for fallback
    const boostSection = section.querySelector('.section--boost-widget-custom');
    const originalHeading = boostSection?.dataset.originalHeading;
    const originalSubheading = boostSection?.dataset.originalSubheading;

    const headingToUse = (widgetData.heading || originalHeading || '').trim();
    if (sectionHeader) {
      sectionHeader.textContent = headingToUse;
      sectionHeader.style.display = headingToUse ? '' : 'none';
    }
    if (sectionHeaderWrap) {
      const hasSubheading = !!(widgetData.subheading || originalSubheading);
      sectionHeaderWrap.style.display = headingToUse || hasSubheading ? '' : 'none';
    }

    if (sectionSubheading) {
      const subheadingToUse = widgetData.subheading || originalSubheading;
      if (subheadingToUse) {
        sectionSubheading.textContent = subheadingToUse;
        sectionSubheading.style.display = '';
      } else {
        sectionSubheading.textContent = '';
        sectionSubheading.style.display = 'none';
      }
    }
  };

  const getWidgetData = (widgetId) => {
    // Try to get widget data from the tab's data attributes
    const activeTab = section.querySelector(`[data-widget-id="${widgetId}"]`);
    if (!activeTab) return null;

    const widgetData = {
      heading: activeTab.dataset.widgetHeading,
      subheading: activeTab.dataset.widgetSubheading
    };

    return widgetData;
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', async (e) => {
      e.preventDefault();
      const { widgetId, blockId } = e.currentTarget.dataset;
      if (!widgetId || !blockId) return;

      if (isTabSwitching) {
        return;
      }

      isTabSwitching = true;

      // Disable all tabs immediately to prevent rapid clicking
      disableAllTabs();

      // Make background color change instant (no transition)
      deactivateAll();
      e.currentTarget.classList.add('active');

      // Update heading immediately for instant feedback (works for both dynamic and static modes)
      updateWidgetHeader(widgetId);

      // Then handle the widget transition
      await activateTab(widgetId, blockId);

      // Re-enable all tabs after transition is complete
      enableAllTabs();
      isTabSwitching = false;
    });
  });

  if (tabs.length > 0) {
    const firstTab = tabs[0];
    const { widgetId, blockId } = firstTab.dataset;
    if (widgetId && blockId) {
      // Hide all widgets first
      widgets.forEach((widget) => widget.classList.add('hidden'));

      deactivateAll();
      firstTab.classList.add('active');

      // Show only the first widget
      const firstWidget = section.querySelector(`#boost-custom-widget-${widgetId}`);
      if (firstWidget) {
        firstWidget.classList.remove('hidden');
        currentWidget = firstWidget;

        // Apply initial button styling to tab content
        const hasViewAllButton = firstWidget.dataset.hasViewAllButton === 'true';
        const tabContent = firstWidget.querySelector('.boost-widget-custom__tab-content');
        if (tabContent && hasViewAllButton) {
          tabContent.classList.add('has-view-all-button');
        }

        // Update heading for initial load (works for both dynamic and static modes)
        updateWidgetHeader(widgetId);
        bindCarouselArrows(currentWidget);
      }
    }
  } else if (widgets.length > 0) {
    // Handle single widget case - show only the first widget
    widgets.forEach((widget, index) => {
      if (index === 0) {
        widget.classList.remove('hidden');
        currentWidget = widget;

        // Apply initial button styling to tab content for single widget
        const hasViewAllButton = widget.dataset.hasViewAllButton === 'true';
        const tabContent = widget.querySelector('.boost-widget-custom__tab-content');
        if (tabContent && hasViewAllButton) {
          tabContent.classList.add('has-view-all-button');
        }
        bindCarouselArrows(currentWidget);
      } else {
        widget.classList.add('hidden');
      }
    });
  }

  // Ensure all tabs are enabled after initialization
  enableAllTabs();
});

const getProducts = async () => {
  const recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
  if (recentlyViewedProducts.length === 0) return {
    products: [],
    total: 0
  };
  const returnedProducts = await fetchProducts(recentlyViewedProducts);
  const formattedProducts = returnedProducts.map((product) => {
    return formatProducts(product);
  })

  const recentlyViewedProductsLocal = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
  const sortedProducts = sortArrayByOrder(formattedProducts, recentlyViewedProductsLocal);

  return {
    products: sortedProducts,
    total: returnedProducts.length
  }
}

function sortArrayByOrder(products, refArray) {
  const orderMap = new Map()

  refArray.forEach((id, index) => {
    orderMap.set(id, index)
  })

  return products.sort((a, b) => {
    return (
      orderMap.get(a.id.split('/').pop()) -
      orderMap.get(b.id.split('/').pop())
    )
  })
}

const formatProducts = (product) => {
  const { node } = product;

  const varaintMetafields = node.variants.edges.flatMap((variant) => {
    return variant.node.metafields.filter(metafield => metafield).map((metafield) => {
      return {
        key: metafield.key,
        namespace: metafield.namespace,
        value: metafield.value
      }
    })
  })

  const productMetafields = node.metafields.filter(metafield => metafield).map((metafield) => {
    return {
      key: metafield.key,
      namespace: metafield.namespace,
      value: metafield.value
    }
  })

  const variants = node.variants.edges.map((variant) => {
    return {
      id: variant.node.id.split('/').pop(),
    }
  })
  const formattedProduct = {
    available: node.totalInventory > 0,
    variants,
    title: node.title,
    price_min: parseFloat(node.priceRange.minVariantPrice.amount),
    price_max: parseFloat(node.priceRange.maxVariantPrice.amount),
    images_info: node.images.nodes.map((image, index) => {
      return {
        src: image.src,
        width: image.width,
        height: image.height,
        alt: image.altText,
        id: image.id,
        position: index + 1
      }
    }),
    collections: node.collections.nodes.map((collection) => {
      return {
        handle: collection.handle,
        id: collection.id,
        title: collection.title
      }
    }),
    vendor: node.vendor,
    id: node.id.split('/').pop(),
    images: node.images.nodes.reduce((acc, image, index) => {
      acc[`${index + 1}`] = image.src;
      return acc;
    }, {}),
    handle: node.handle,
    compare_at_price_min: parseFloat(node.compareAtPriceRange.minVariantPrice.amount),
    compare_at_price_max: parseFloat(node.compareAtPriceRange.maxVariantPrice.amount),
    tags: node.tags,
    metafields: [...varaintMetafields, ...productMetafields],
    product_type: node.productType,
    product_category: node.category?.name || '',
  };

  return formattedProduct;
}


async function fetchProducts(ids, queryNumber = 48) {
  let formattedIds = [...new Set(ids)]
  if (formattedIds.every((item) => item === '')) return []
  formattedIds = formattedIds.filter((item) => item !== '')
  const queryIds = formattedIds.map((id) => `id:${id}`).join(' OR ')

  let graphQLQuery = ''
  const maxWidth = window.innerWidth < 768 ? 343 : 480
  const maxHeight = window.innerWidth < 768 ? 459 : 526

  const metafields = [
    { key: "grouping", namespace: "bac" },
    { key: "stock_availability_tag", namespace: "lab" },
    { key: "product_status_labels", namespace: "lab" },
    { key: "promotion_labels", namespace: "lab" },
    { key: "free_shipping", namespace: "bac" },
    { key: "shipping_method", namespace: "bac" },
    { key: "set_of", namespace: "bac" }
  ]

  const identifiersString = metafields
  .map(({ namespace, key }) => `{key: "${key}", namespace: "${namespace}"}`)
  .join(",");

  if (queryIds)
    graphQLQuery = `{
        products(first: ${queryNumber}, query: "${queryIds}") {
          edges {
            node {
              id
              handle
              title
              handle
              tags
              vendor
              productType
              category {
                name
              }
              images(first: 20) {
                nodes {
                  id
                  altText
                  height
                  src
                  width
                  transformedSrc(maxWidth: ${maxWidth}, maxHeight: ${maxHeight})
                }
              }
              collections(first: 10) {
                nodes {
                  handle
                  id
                  title
                }
              }
              priceRange {
                minVariantPrice {
                  amount
                }
                maxVariantPrice {
                  amount
                }
              }
              compareAtPriceRange {
                minVariantPrice {
                  amount
                }
                maxVariantPrice {
                  amount
                }
              }
              metafields(identifiers: [${identifiersString}]) {
                namespace
                key
                value
              }
              variants(first: 10) {
                edges {
                  node {
                    id
                    metafields(identifiers: [${identifiersString}]) {
                      namespace
                      key
                      value
                    }
                  }
                }
              }
              totalInventory
            }
          }
        }
      }`

  if (graphQLQuery) {
    const data = await executeQuery(graphQLQuery)
    return data
  }
  return []
}

async function executeQuery(graphQLQuery) {
  /* eslint-disable-next-line no-undef */
  const SHOPIFY_STORE_DOMAIN = Shopify.shop
  // this access_token is just for storefront
  const ACCESS_TOKEN = window.theme.apiKeys.storefrontAccessToken

  try {
    const response = await fetch(
      `https://${SHOPIFY_STORE_DOMAIN}/api/2025-04/graphql`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/graphql',
          'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN,
        },
        body: graphQLQuery,
      }
    )
    const data = await response.json()
    return data.data.products.edges
  } catch (error) {
    console.error('Error:', error)
    return []
  }
}

function optimizeCloudinaryUrl(url, transform = "f_auto,q_auto,w_15,h_15,c_limit") {
  const uploadSegment = "/upload/";

  if (!url.includes(uploadSegment)) {
    console.error("Not a valid Cloudinary URL with '/upload/' in it.");
    return url;
  }

  return url.replace(uploadSegment, `/upload/${transform}/`);
}



class BoostWidgetCustomRecommendations extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
    this.swiper = null;
  }

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.blockId = this.dataset.blockId;
    this.apiEndpoint = this.dataset.apiEndpoint;
    this.shopDomain = this.dataset.shopDomain;
    this.tenantId = this.dataset.tenantId;
    this.widgetId = this.dataset.widgetId;
    this.collectionId = this.dataset.collectionId;
    this.limit = parseInt(this.dataset.limit) || 12;
    this.recommendationType = this.dataset.recommendationType || 'hand-picked-products';
    this.locale = this.dataset.locale || 'en';
    this.enableSlider = this.dataset.enableSlider === 'true';
    this.columnsDesktop = parseFloat(this.dataset.columnsDesktop) || 4;
    this.columnsTablet = parseInt(this.dataset.columnsTablet) || 3;
    this.columnsMobile = parseFloat(this.dataset.columnsMobile) || 2.5;
    this.hasViewAllButton = this.dataset.hasViewAllButton === 'true';

    // New data attributes for featured-products-tab layout
    this.columnGap = this.dataset.columnGap || 'medium';
    this.rowGap = this.dataset.rowGap || 'inherit';
    this.enableSwipeMobile = this.dataset.enableSwipeMobile === 'true';
    this.pcardImageRatio = this.dataset.pcardImageRatio || '3/4';
    this.pcardThumbnailRatio = this.dataset.pcardThumbnailRatio || '';
    this.enableVideoAutoplay = this.dataset.enableVideoAutoplay === 'true';
    this.sectionIndex = this.dataset.sectionIndex || '0';

    // Page type override for API requests (e.g., 'home_page' to show homepage widgets on other pages)
    this.pageTypeOverride = this.dataset.pageTypeOverride || null;

    // Get product ID if on product page
    this.productId = this.dataset.productId || this.getProductIdFromPage();

    this.loadingElement = this.querySelector('.boost-widget-custom__loading');
    this.errorElement = this.querySelector('.boost-widget-custom__error');
    this.contentElement = this.querySelector('.boost-widget-custom__products-content');

    this.style.overflow = 'hidden';
    this.style.position = 'relative';
    this.applyLockedMinHeight();

    // Apply height class based on view all button presence
    if (this.hasViewAllButton) {
      this.classList.add('has-view-all-button');
    }

    if (!this.classList.contains('hidden')) {
      this.loadRecommendations();
    }

  }

  getSectionElement() {
    return document.getElementById(`shopify-section-${this.sectionId}`);
  }

  applyLockedMinHeight() {
    const sectionEl = this.getSectionElement();
    const lockedHeight = sectionEl?.dataset?.boostLockedMinHeight;
    if (!lockedHeight) return;

    this.style.minHeight = `${lockedHeight}px`;

    const panel = sectionEl.querySelector('.tabs__panel');
    if (panel) {
      panel.style.minHeight = `${lockedHeight}px`;
    }

    const container = sectionEl.querySelector('.boost-widget-custom__container');
    if (container) {
      container.style.minHeight = `${lockedHeight}px`;
    }
  }

  waitForImages(timeoutMs = 2000) {
    const images = Array.from(this.querySelectorAll('img'));
    if (images.length === 0) return Promise.resolve();

    return new Promise((resolve) => {
      let remaining = images.length;
      const done = () => {
        remaining -= 1;
        if (remaining <= 0) resolve();
      };

      const timer = setTimeout(resolve, timeoutMs);
      images.forEach((img) => {
        if (img.complete) {
          done();
          return;
        }
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      });

      Promise.resolve().then(() => {
        if (remaining <= 0) {
          clearTimeout(timer);
          resolve();
        }
      });
    });
  }

  async lockSectionMinHeight() {
    const sectionEl = this.getSectionElement();
    if (!sectionEl || sectionEl.dataset.boostLockedMinHeight) {
      this.applyLockedMinHeight();
      return;
    }

    await this.waitForImages();

    await new Promise((resolve) => {
      requestAnimationFrame(() => requestAnimationFrame(resolve));
    });

    if (sectionEl.dataset.boostLockedMinHeight) {
      this.applyLockedMinHeight();
      return;
    }

    const height = Math.ceil(this.getBoundingClientRect().height);
    if (height <= 0) return;

    // Remember the first loaded widget height for subsequent tab switches
    sectionEl.dataset.boostLockedMinHeight = String(height);
    sectionEl.style.setProperty('--boost-widget-min-height', `${height}px`);

    const panel = sectionEl.querySelector('.tabs__panel');
    if (panel) {
      panel.style.minHeight = `${height}px`;
    }

    const container = sectionEl.querySelector('.boost-widget-custom__container');
    if (container) {
      container.style.minHeight = `${height}px`;
    }

    sectionEl.querySelectorAll('boost-widget-custom-recommendations').forEach((widget) => {
      widget.style.minHeight = `${height}px`;
    });

    this.prefetchSiblingWidgets();
  }

  prefetchSiblingWidgets() {
    const sectionEl = this.getSectionElement();
    if (!sectionEl) return;

    sectionEl.querySelectorAll('boost-widget-custom-recommendations').forEach((widget) => {
      if (widget === this) return;
      if (widget.initialized) return;
      if (typeof widget.loadRecommendations === 'function') {
        widget.loadRecommendations();
      }
    });
  }

  getProductIdFromPage() {
    // Check if we're on a product page by looking for product-info element
    const productInfo = document.querySelector('product-info[data-product-id]');
    if (productInfo) {
      return productInfo.dataset.productId;
    }

    // Alternative: check for product ID in meta tags
    const productMeta = document.querySelector('meta[property="og:type"][content="product"]');
    if (productMeta) {
      // Try to get product ID from various sources
      const productIdElement = document.querySelector('[data-product-id]');
      if (productIdElement) {
        return productIdElement.dataset.productId;
      }
    }

    return null;
  }

  async loadRecommendations() {
    if (this.initialized) return;

    try {
      this.showContent();
      let data = [];
      if(this.recommendationType === 'recently-viewed') {
        data = await getProducts();
      } else {
        let ruleBased = null;
        if(this.recommendationType === 'related-items') {
          const widgetPlacement = this.widgetId.split('-')[0].replace('page', '-page');
          ruleBased = window.boostWidgetIntegration.app.production?.recommendationWidgets[widgetPlacement]?.[this.widgetId]?.params?.ruleBased || null;
        }

        const requestBody = {
          collectionId: this.collectionId ? parseInt(this.collectionId) : 0,
          recommendationType: this.recommendationType,
          limit: this.limit,
          shop: this.tenantId || this.shopDomain,
          wid: this.widgetId,
          event_type: 'init',
          locale: this.locale,
          layoutDisplay: 'carousel',
          return_all_currency_fields: false,
          debug: false,
          ruleBased,
        };

        // Add page type override if specified (e.g., 'home_page' to show homepage widgets elsewhere)
        if (this.pageTypeOverride) {
          requestBody.pg = this.pageTypeOverride;
        }

        // Add productIds array if we're on a product page
        if (this.productId) {
          requestBody.productIds = [parseInt(this.productId)];
        }

        const shop = this.tenantId || this.shopDomain;
        const recommendationApiEndPoint = `${this.apiEndpoint}?event_type=init&shop=${shop}&wid=${this.widgetId}&recommendationType=${this.recommendationType}`;

        const response = await fetch(recommendationApiEndPoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        data = await response.json();
      }

      if (data.products && data.products.length > 0) {
        await this.renderProducts(data.products);
        this.initialized = true;
        await this.lockSectionMinHeight();

        // Only manage section visibility if this is NOT a stacked widget
        const isStacked = this.closest('.boost-widget-custom__container--stacked');
        if (!isStacked) {
          this.getSectionElement()?.classList.remove('hidden');
        }
      } else {
        // Hide only this widget, not the entire section (for stacked layouts)
        const isStacked = this.closest('.boost-widget-custom__container--stacked');
        if (isStacked) {
          // In stacked mode, hide the parent stacked-section div
          const stackedSection = this.closest('.boost-widget-custom__stacked-section');
          if (stackedSection) {
            stackedSection.style.display = 'none';
          }
        } else {
          this.classList.add('hidden');
          // Only hide the whole section if nothing has successfully loaded yet
          const sectionEl = this.getSectionElement();
          const hasLoadedSibling = sectionEl
            ? Array.from(sectionEl.querySelectorAll('boost-widget-custom-recommendations')).some(
                (widget) => widget !== this && widget.initialized,
              )
            : false;
          if (!hasLoadedSibling) {
            sectionEl?.classList.add('hidden');
          }
        }
      }
    } catch (error) {
      console.error('Error fetching boost widget custom recommendations:', error);
      this.classList.add('hidden');
    }
  }

  async onWidgetActivated() {
    if (!this.initialized) {
      await this.loadRecommendations();
    }
  }

  async renderProducts(products) {
    // Use the same structure as featured-products-tab but with swiper support
    const productsToShow = Math.min(products.length, this.limit);

    if (this.enableSlider) {
      // Swiper layout with original boost product cards
      const productCards = products.slice(0, productsToShow).map((product) =>
        BoostWidgetCustomRecommendations.createProductCard(product, true)
      );

      // Add empty slide if there is only one product to make the slider to be responsive
      if (productCards.length === 1) {
        productCards.push('<div class="swiper-slide boost-sd__slide"></div>');
      }

      const swiperStructure = `
        <div class="swiper">
          <div class="swiper-wrapper">
            ${productCards.join('')}
          </div>
        </div>
      `;

      if (this.contentElement) {
        this.contentElement.innerHTML = swiperStructure;
      }

      // Initialize swiper after content is rendered
      this.initializeSwiper();
      this.dispatchEvent(new CustomEvent('boost-widget:swiper-ready', { bubbles: true }));

      // Update and add wishlist button event listeners
      updateWishlistButton(this.sectionId);
      this.attachWishlistButtonListeners();
    } else {
      // Grid layout with original boost product cards
      const productCards = products.slice(0, productsToShow).map((product) =>
        BoostWidgetCustomRecommendations.createProductCard(product, false)
      );

      const gridStructure = `
        <div class="boost-widget-custom__grid f-grid f-grid-${this.columnsMobile}-cols md:f-grid-${this.columnsTablet}-cols lg:f-grid--row-gap-${this.rowGap}" style="min-height: 480px;">
          ${productCards.join('')}
        </div>
      `;

      if (this.contentElement) {
        this.contentElement.innerHTML = gridStructure;
      }

      // Update and add wishlist button event listeners
      updateWishlistButton(this.sectionId);
      this.attachWishlistButtonListeners();
    }
  }

  static createProductCard(product, isSlider = true) {
    let imageUrl = '';
    let secondImageUrl = '';

    if (product.images_info && product.images_info.length > 0) {
      imageUrl = product.images_info[0].src;
      if (product.images_info.length > 1) {
        secondImageUrl = product.images_info[1].src;
      }
    } else if (product.images && product.images.length > 0) {
      imageUrl = product.images[0];
      if (product.images.length > 1) {
        secondImageUrl = product.images[1];
      }
    } else if (product.featured_image) {
      imageUrl = product.featured_image;
    }

    let price = '0';
    let comparePrice = '';
    let hasSale = false;

    if (product.price_min) {
      price = product.price_min;
    } else if (product.price) {
      price = product.price;
    }

    if (product.compare_at_price_min && product.compare_at_price_min > product.price_min) {
      comparePrice = product.compare_at_price_min;
      hasSale = true;
    } else if (product.compare_at_price && product.compare_at_price > product.price) {
      comparePrice = product.compare_at_price;
      hasSale = true;
    }

    const productHandle = product.handle || product.url?.split('/products/')?.[1] || '';
    const productUrl = productHandle ? `/products/${productHandle}` : '#';
    const productTitle = product.title || 'Product';
    const productVendor = product.vendor || '';
    const reviewRatings = product.review_ratings;

    const findMetafield = (namespace, key) => {
      if (!product.metafields || !Array.isArray(product.metafields)) {
        return null;
      }
      return product.metafields.find(metafield =>
        metafield.namespace === namespace && metafield.key === key
      );
    };
    // BAC Color Swatches
    let colorSwatchesHtml = '';
    const bacGroupingMetafield = findMetafield('bac', 'grouping');
    if (bacGroupingMetafield && bacGroupingMetafield.value) {
      let colorItems = [];
      try {
        const bacGrouping = bacGroupingMetafield.value;

        if (typeof bacGrouping === 'string') {
          // Parse the JSON string value
          colorItems = JSON.parse(bacGrouping);
        } else if (Array.isArray(bacGrouping)) {
          colorItems = bacGrouping;
        }
      } catch (e) {
        console.warn('Error parsing BAC grouping:', e);
      }

      if (colorItems.length > 0) {
        const swatches = colorItems.map(item => {
          const colorName = (item.name || '').toLowerCase();
          const productId = item.product_id || '';
          const colourImage = item.colour_image || '';
          const colourCode = item.colour_code || '';

          // Use colour_image if available, otherwise use colour_code
          let swatchContent = '';
          if (colourImage && colourImage.trim() !== '') {
            swatchContent = `<img src="${optimizeCloudinaryUrl(colourImage)}" alt="${item.name || ''}" class="boost-sd__swatch-image" width="15" height="15" loading="lazy" fetchpriority="low" />`;
          } else if (colourCode && colourCode.trim() !== '') {
            swatchContent = `<div class="boost-sd__swatch-color" style="background-color: ${colourCode};"></div>`;
          } else {
            // Fallback to empty swatch that can be enhanced by existing logic
            swatchContent = `<div class="boost-sd__swatch-color"></div>`;
          }

          return `
            <div class="boost-sd__color-swatch" data-color-name="${colorName}" data-product-id="${productId}">
              ${swatchContent}
            </div>
          `;
        }).join('');

        colorSwatchesHtml = `<div class="boost-sd__bac-color-swatches">${swatches}</div>`;
      }
    }

    // Stock Availability
    let stockAvailabilityHtml = '';
    const stockAvailabilityMetafield = findMetafield('lab', 'stock_availability_tag');
    if (stockAvailabilityMetafield && stockAvailabilityMetafield.value) {
      const stockTag = stockAvailabilityMetafield.value;
      let cssClass = '';
      let iconHtml = '';

      switch (stockTag.toLowerCase()) {
        case 'in stock':
          cssClass = 'stock-green';
          iconHtml = `<div class="stock-circle stock-circle-green">
            <svg class="tick-icon" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 14 14" fill="none">
              <path d="M12.1352 2L5.97813 8.08525L2.96898 5.14552L2 6.17116L5.97815 10L13 2.95705L12.1352 2Z" fill="white" stroke="white" stroke-width="1"/>
            </svg>
          </div>`;
          break;
        case 'in stock soon':
          cssClass = 'stock-yellow';
          iconHtml = '<span class="stock-circle stock-circle-yellow"></span>';
          break;
        case 'out of stock':
          cssClass = 'stock-grey';
          iconHtml = '<span class="stock-circle stock-circle-grey"></span>';
          break;
        case 'available for order':
          cssClass = 'stock-turquoise';
          iconHtml = '<span class="stock-circle stock-circle-turquoise"></span>';
          break;
        default:
          cssClass = '';
          iconHtml = '';
          break;
      }

      if (cssClass) {
        stockAvailabilityHtml = `<span class="boost-sd__stock-availability-tag ${cssClass}">${iconHtml} ${stockTag}</span>`;
      }
    }

    let topLabelsHtml = '';
    const topLabels = [];

    // Product Status Labels (lab.product_status_labels) - TOP labels
    const productStatusLabelsMetafield = findMetafield('lab', 'product_status_labels');
    if (productStatusLabelsMetafield && productStatusLabelsMetafield.value) {
      const productStatusLabels = productStatusLabelsMetafield.value;
      let labelClass = 'boost-sd__product-labels';

      if (productStatusLabels.includes('New') || productStatusLabels === 'New') {
        labelClass += ' boost-sd__product-labels--new';
      } else if (productStatusLabels.includes('Best Seller') || productStatusLabels === 'Best Seller') {
        labelClass += ' boost-sd__product-labels--best-seller';
      } else if (productStatusLabels.includes('Trending') || productStatusLabels === 'Trending') {
        labelClass += ' boost-sd__product-labels--trending';
      }

      topLabels.push(`<div class="${labelClass}">${productStatusLabels}</div>`);
    }

    // Promotion Labels (lab.promotion_labels) - TOP labels
    const promotionLabelsMetafield = findMetafield('lab', 'promotion_labels');
    if (promotionLabelsMetafield && promotionLabelsMetafield.value) {
      const promotionLabels = promotionLabelsMetafield.value;
      let showLabel = true;
      let labelClass = 'boost-sd__product-labels';


      // Special logic for Sale label - only show if there's actually a sale
      if (promotionLabels.includes('Sale') || promotionLabels === 'Sale') {
        // Check if product.compare_at_price_max is blank or price_max >= compare_at_price_max
        if (!product.compare_at_price_max || (product.price_max && product.price_max >= product.compare_at_price_max)) {
          showLabel = false;
        } else {
          labelClass += ' boost-sd__product-labels--sale';
        }
      }

      if (promotionLabels.includes('Clearance') || promotionLabels === 'Clearance') {
        labelClass += ' boost-sd__product-labels--clearance';
      }
      if (promotionLabels.includes('Wait & Save') || promotionLabels === 'Wait & Save') {
        labelClass += ' boost-sd__product-labels--wait-and-save';
      }
      if (promotionLabels.includes('Early Bird') || promotionLabels === 'Early Bird') {
        labelClass += ' boost-sd__product-labels--early-bird';
      }
      if (promotionLabels.includes('Package Deal') || promotionLabels === 'Package Deal') {
        labelClass += ' boost-sd__product-labels--package-deal';
      }

      if (showLabel) {
        topLabels.push(`<div class="${labelClass}">${promotionLabels}</div>`);
      }
    }

    if (topLabels.length > 0) {
      topLabelsHtml = `<div class="boost-sd__label-container top">${topLabels.join('')}</div>`;
    }

    // BOTTOM LABELS CONTAINER
    let bottomLabelsHtml = '';
    const bottomLabels = [];

    // Free Shipping and Shipping Method Labels (bac namespace) - BOTTOM labels
    const freeShippingMetafield = findMetafield('bac', 'free_shipping');
    const shippingMethodMetafield = findMetafield('bac', 'shipping_method');

    let freeShippingFound = false;
    let freeShippingValue = '';
    let shippingMethodFound = false;
    let shippingMethodValue = '';

    if (freeShippingMetafield && freeShippingMetafield.value) {
      freeShippingValue = freeShippingMetafield.value;
      freeShippingFound = true;
      if (freeShippingValue === '-FreeShipping-') {
        freeShippingValue = 'Free Shipping';
      }
    }

    if (shippingMethodMetafield && shippingMethodMetafield.value) {
      shippingMethodValue = shippingMethodMetafield.value;
      shippingMethodFound = true;
      if (shippingMethodValue === '-MustDelivery-') {
        shippingMethodValue = 'Delivery Only';
      } else if (shippingMethodValue === '-MustPickup-') {
        shippingMethodValue = 'Pick Up Only';
      } else if (shippingMethodValue === '-Pickup&Delivery-') {
        shippingMethodFound = false;
      }
    }

    // Apply the same logic as in Liquid template
    if (freeShippingFound && freeShippingValue) {
      bottomLabels.push(`<div class="boost-sd__product-labels free_shipping">${freeShippingValue}</div>`);
    } else if (shippingMethodFound && shippingMethodValue && shippingMethodValue !== '-Pickup&Delivery-') {
      bottomLabels.push(`<div class="boost-sd__product-labels shipping_method">${shippingMethodValue}</div>`);
    }

    if (bottomLabels.length > 0) {
      bottomLabelsHtml = `<div class="boost-sd__label-container bottom">${bottomLabels.join('')}</div>`;
    }
    // For Set product
    const valueSetOf = findMetafield('bac', 'set_of');
    let setOfLabel = '';
    if (valueSetOf) {
      const perUnitPrice = Math.floor((price / valueSetOf.value) * 100) / 100;
      const isOnSale = product.price_min < product.compare_at_price_min;
      setOfLabel = `<span class="boost-sd__product-price boost-sd__product-price--set ${isOnSale ? 'boost-sd__product-price--sale' : ''}">$${perUnitPrice}/ea.</span>`;
    }

    const cardClass = isSlider ? 'swiper-slide' : '';

    // Helper to generate Shopify CDN image URLs with width and format
    function getShopifyImageUrl(baseUrl, width, format, quality = 80) {
      if (!baseUrl) return '';
      try {
        const url = new URL(baseUrl);
        url.searchParams.set('width', String(width));
        if (format) url.searchParams.set('format', format);
        if (quality) url.searchParams.set('quality', String(quality));
        return url.toString();
      } catch {
        // fallback for relative URLs or if URL constructor fails
        let url = baseUrl.includes('?') ? `${baseUrl}&` : `${baseUrl}?`;
        url += `width=${width}`;
        if (format) url += `&format=${format}`;
        if (quality) url += `&quality=${quality}`;
        return url;
      }
    }

    const renderOptimizedImage = (
      imgUrl,
      imgAlt = "Product image",
      className = "boost-sd__product-image-main",
      loading = "lazy",
    ) => {
      return `
        <picture>
          <source
            media="(max-width: 480px)"
            srcset="${getShopifyImageUrl(imgUrl, 200, 'jpeg', 100)}"
            type="image/jpeg"
          />
          <source
            media="(max-width: 650px)"
            srcset="${getShopifyImageUrl(imgUrl, 270, 'jpeg', 100)}"
            type="image/jpeg"
          />
          <source
            media="(max-width: 768px)"
            srcset="${getShopifyImageUrl(imgUrl, 320, 'jpeg', 100)}"
            type="image/jpeg"
          />
          <source
            srcset="${getShopifyImageUrl(imgUrl, 328, 'jpeg', 100)}"
            type="image/jpeg"
          />
          <img
            class="${className}"
            src="${getShopifyImageUrl(imgUrl, 135, 'jpeg', 100)}"
            width="135"
            height="180"
            alt="${imgAlt}"
            loading="${loading}"
            fetchpriority="${loading === 'lazy' ? 'low' : 'high'}"
          />
        </picture>
      `;
    };

    return `
      <div class="${cardClass} boost-sd__slide">
        <div class="boost-sd__product-item" data-id="${product.id}">
          <div class="boost-sd__product-link-image">
            <button
              class="wishlist-button"
              aria-label="Add to wishlist"
              type="button"
              data-product-id="${product.id}"
              data-variant-id="${product.variants[0].id}"
              data-product-url="${productUrl}"
              data-product-img="${imageUrl}"
              data-added-to-wishlist="false"
            >
              <svg
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 16.5L8.55 15.1995C4.4 11.36 1.5 8.69 1.5 5.5C1.5 3.14 3.39 1.25 5.75 1.25C7.07 1.25 8.34 1.86 10 2.93C11.66 1.86 12.93 1.25 14.25 1.25C16.61 1.25 18.5 3.14 18.5 5.5C18.5 8.69 15.6 11.36 11.45 15.1995L10 16.5Z"
                  fill="none"
                  stroke="#262525"
                  strokeWidth="1.5"
                  class="wishlist-heart-path"
                />
              </svg>
            </button>
            <a href="${productUrl}" aria-label="${productTitle}">
              <div class="boost-sd__product-image">
                ${imageUrl ? `
                  ${renderOptimizedImage(imageUrl, productTitle, "boost-sd__product-image-main", "lazy")}
                  ${secondImageUrl ? renderOptimizedImage(secondImageUrl, productTitle, "boost-sd__product-image-hover", "lazy") : ''}
                ` : `
                  <div class="boost-sd__product-image-placeholder">
                    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                      <rect width="100" height="100" fill="#e5e5e5"/>
                      <text x="50" y="50" text-anchor="middle" dy=".3em" fill="#999">Product</text>
                    </svg>
                  </div>
                `}
              </div>
            </a>
            ${topLabelsHtml}
            ${bottomLabelsHtml}
          </div>

          <div class="boost-sd__product-info-wrapper">
            <div class="boost-sd__product-info">
              <div class="boost-sd__vendor-rating-wrapper">
                ${productVendor ? `
                  <p class="boost-sd__product-vendor">
                    ${productVendor}
                  </p>
                ` : ''}
                ${reviewRatings ? `<div class="oke-sr-rating"><svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 0L5.18241 4.60852L0 5.34759L3.75 8.93481L2.86483 14L7.5 11.6085L12.1352 14L11.25 8.93481L15 5.34759L9.81759 4.60852L7.5 0Z" fill="#D29126"/></svg> ${reviewRatings}</div>` : ''}
              </div>

              <a aria-label="${productTitle}" class="boost-sd__product-link" href="${productUrl}">
                <div class="boost-sd__product-title" id="product-title-${product.id}">
                  ${productTitle}
                </div>
              </a>

              <div class="boost-sd__product-price-content" id="product-price-${product.id}">
                <div class="boost-sd__product-price--left">
                ${hasSale ? `
                  <span class="boost-sd__product-price boost-sd__product-price--sale">$${price.toFixed(2)}</span>
                  <span class="boost-sd__product-price boost-sd__product-price--compare">$${comparePrice.toFixed(2)}</span>
                  ` : `
                  <span class="boost-sd__product-price">$${price.toFixed(2)}</span>
                `}
                </div>
                ${setOfLabel}
              </div>

              ${BoostWidgetCustomRecommendations.renderSizeAvailability(product)}

              ${colorSwatchesHtml}
              ${stockAvailabilityHtml}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  initializeSwiper() {
    const swiperElement = this.querySelector('.swiper');
    if (!swiperElement || typeof Swiper === 'undefined') return;

    const slides = this.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    this.swiper = new Swiper(swiperElement, {
      slidesPerView: this.columnsMobile || 2.5,
      spaceBetween: 10,
      resistanceRatio: 0,
      freeMode: false,
      breakpoints: {
        360: {
          slidesPerView: this.columnsMobile || 2.5,
          spaceBetween: 10,
          slidesOffsetAfter: 15,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 10,
          slidesOffsetAfter: 0,
        },
        1024: {
          slidesPerView: 'auto',
          spaceBetween: 10,
        },
      },
      loop: false,
      threshold: 2,
    });
  }

  createProductCard(product) {
    // Convert boost product data to match Shopify product format
    const shopifyProduct = {
      id: product.id,
      title: product.title || 'Product',
      handle: product.handle || product.url?.split('/products/')?.[1] || '',
      vendor: product.vendor || '',
      price: product.price_min || product.price || 0,
      compare_at_price: product.compare_at_price_min || product.compare_at_price || null,
      featured_image: this.getProductImage(product),
      images: this.getProductImages(product),
      available: product.available !== false,
      variants: [{
        id: product.id,
        title: 'Default Title',
        price: product.price_min || product.price || 0,
        compare_at_price: product.compare_at_price_min || product.compare_at_price || null,
        available: product.available !== false
      }],
      metafields: this.extractMetafields(product)
    };

    return `
      <div class="product-card product-card--overlay" data-product-id="${shopifyProduct.id}">
        <div class="product-card__media">
          <a href="/products/${shopifyProduct.handle}" class="product-card__link">
            <div class="product-card__image-wrapper">
              <img
                src="${shopifyProduct.featured_image}"
                alt="${shopifyProduct.title}"
                class="product-card__image"
                loading="lazy"
                width="400"
                height="533"
              />
            </div>
          </a>
          ${this.renderProductLabels(product)}
        </div>
        <div class="product-card__info">
          <div class="product-card__vendor">
            ${shopifyProduct.vendor}
          </div>
          <h3 class="product-card__title">
            <a href="/products/${shopifyProduct.handle}">${shopifyProduct.title}</a>
          </h3>
          <div class="product-card__price">
            ${this.renderProductPrice(product)}
          </div>
          ${this.renderColorSwatches(product)}
        </div>
      </div>
    `;
  }

  getProductImage(product) {
    if (product.images_info && product.images_info.length > 0) {
      return product.images_info[0].src;
    } else if (product.images && product.images.length > 0) {
      return product.images[0];
    } else if (product.featured_image) {
      return product.featured_image;
    }
    return '/assets/no-image.png'; // Fallback image
  }

  getProductImages(product) {
    if (product.images_info && product.images_info.length > 0) {
      return product.images_info.map(img => img.src);
    } else if (product.images && product.images.length > 0) {
      return product.images;
    }
    return [this.getProductImage(product)];
  }

  extractMetafields(product) {
    const metafields = [];

    // Extract BAC color swatches
    if (product.bac_grouping) {
      metafields.push({
        namespace: 'bac',
        key: 'grouping',
        value: product.bac_grouping
      });
    }

    // Extract stock availability
    if (product.stock_availability_tag) {
      metafields.push({
        namespace: 'lab',
        key: 'stock_availability_tag',
        value: product.stock_availability_tag
      });
    }

    // Extract product status labels
    if (product.product_status_labels) {
      metafields.push({
        namespace: 'lab',
        key: 'product_status_labels',
        value: product.product_status_labels
      });
    }

    // Extract promotion labels
    if (product.promotion_labels) {
      metafields.push({
        namespace: 'lab',
        key: 'promotion_labels',
        value: product.promotion_labels
      });
    }

    return metafields;
  }

  renderProductLabels(product) {
    let labelsHtml = '';

    // Product status labels
    if (product.product_status_labels) {
      const labels = product.product_status_labels.split(',').map(label => label.trim());
      labels.forEach(label => {
        let labelClass = 'product-card__label';
        if (label.includes('New')) labelClass += ' product-card__label--new';
        else if (label.includes('Best Seller')) labelClass += ' product-card__label--best-seller';
        else if (label.includes('Trending')) labelClass += ' product-card__label--trending';

        labelsHtml += `<span class="${labelClass}">${label}</span>`;
      });
    }

    // Promotion labels
    if (product.promotion_labels) {
      const labels = product.promotion_labels.split(',').map(label => label.trim());
      labels.forEach(label => {
        let labelClass = 'product-card__label';
        if (label.includes('Sale')) labelClass += ' product-card__label--sale';
        else if (label.includes('Clearance')) labelClass += ' product-card__label--clearance';

        labelsHtml += `<span class="${labelClass}">${label}</span>`;
      });
    }

    if (labelsHtml) {
      return `<div class="product-card__labels">${labelsHtml}</div>`;
    }

    return '';
  }

  renderProductPrice(product) {
    const price = product.price_min || product.price || 0;
    const comparePrice = product.compare_at_price_min || product.compare_at_price || null;

    if (comparePrice && comparePrice > price) {
      return `
        <span class="product-card__price--sale">$${price}</span>
        <span class="product-card__price--compare">$${comparePrice}</span>
      `;
    }

    return `<span class="product-card__price">$${price}</span>`;
  }

  static renderSizeAvailability(product) {
    // Check if product has size options
    if (product.options_with_values && Array.isArray(product.options_with_values)) {
      const sizeOption = product.options_with_values.find(option =>
        option.name && option.name.toLowerCase() === 'size'
      );

      if (sizeOption && sizeOption.values && sizeOption.values.length > 1) {
        return '<div class="boost-sd__size-availability">Available in other sizes</div>';
      }
    }

    return '';
  }

  renderColorSwatches(product) {
    if (!product.bac_grouping) return '';

    try {
      const colorItems = typeof product.bac_grouping === 'string'
        ? JSON.parse(product.bac_grouping)
        : product.bac_grouping;

      if (!Array.isArray(colorItems) || colorItems.length === 0) return '';

      const swatches = colorItems.map(item => {
        const colorName = (item.name || '').toLowerCase();
        const productId = item.product_id || '';
        const colourImage = item.colour_image || '';
        const colourCode = item.colour_code || '';

        let swatchContent = '';
        if (colourImage && colourImage.trim() !== '') {
          swatchContent = `<img src="${colourImage}" alt="${item.name || ''}" class="color-swatch__image" />`;
        } else if (colourCode && colourCode.trim() !== '') {
          swatchContent = `<div class="color-swatch__color" style="background-color: ${colourCode};"></div>`;
        } else {
          swatchContent = `<div class="color-swatch__color"></div>`;
        }

        return `
          <div class="color-swatch" data-color-name="${colorName}" data-product-id="${productId}">
            ${swatchContent}
          </div>
        `;
      }).join('');

      return `<div class="product-card__color-swatches">${swatches}</div>`;
    } catch (e) {
      console.warn('Error parsing BAC grouping:', e);
      return '';
    }
  }

  showLoading() {
    this.showContent();
  }

  showContent() {
    this.loadingElement.style.display = 'none';
    this.errorElement.style.display = 'none';
    this.contentElement.style.display = 'block';
    this.classList.remove('hidden');
  }

  showError() {
    this.classList.add('hidden');
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }

  attachWishlistButtonListeners() {
    const wishlistButtons = this.querySelectorAll('.wishlist-button');
    wishlistButtons.forEach(button => {
      // Remove any existing listeners to prevent duplicates
      button.removeEventListener('click', this.handleWishlistButtonClick);
      // Add the new listener
      button.addEventListener('click', this.handleWishlistButtonClick.bind(this));
    });
  }

  handleWishlistButtonClick(e) {
    const btn = e.currentTarget;
    if (!btn) return;

    const productData = {
      epi: parseInt(
        btn.dataset.variantId || btn.dataset.productId
      ),
      empi: parseInt(btn.dataset.productId),
      du: `https://www.urbansales.co.nz${btn.dataset.productUrl}`,
      iu: btn.dataset.productImg,
      source: "recommendations",
      et: 4,
      cart: "",
      uri: window.location.href,
      dt: document.title,
      ct: "",
      rc: "default",
      type: "product-variant",
      ru: window.location.href,
    };

    window._swat.fetch(function(swat) {
      const isInWishlist = swat.some(item => item.empi === productData.empi);
      if (isInWishlist) {
        window._swat.removeFromWishList(productData, function() {
          btn.classList.remove('wishlist-button-active');
          btn.setAttribute('data-added-to-wishlist', 'false');
        });
      } else {
        window._swat.addToWishList(productData, function() {
          btn.classList.add('wishlist-button-active');
          btn.setAttribute('data-added-to-wishlist', 'true');
        });
      }
    });
  }
}

customElements.define('boost-widget-custom-recommendations', BoostWidgetCustomRecommendations);

function waitForSwat() {
  return new Promise((resolve) => {
    if (window._swat) {
      resolve(window._swat);
      return;
    }

    // Watch for changes to window object
    const observer = new MutationObserver(() => {
      if (window._swat) {
        observer.disconnect();
        resolve(window._swat);
      }
    });

    // Start observing
    observer.observe(document, {
      childList: true,
      subtree: true
    });

    // Also check periodically as fallback
    const interval = setInterval(() => {
      if (window._swat) {
        clearInterval(interval);
        observer.disconnect();
        resolve(window._swat);
      }
    }, 100);

    // Timeout after 10 seconds
    setTimeout(() => {
      clearInterval(interval);
      observer.disconnect();
      resolve(null);
    }, 10000);
  });
}

async function updateWishlistButton(sectionId) {
  const swat = await waitForSwat();
  if (swat && swat.fetch) {
    swat.fetch(function(wishlistProducts) {
      wishlistProducts.forEach((product) => {
        const wishlistButton = document.querySelector(`#shopify-section-${sectionId} .wishlist-button[data-product-id="${product.empi}"]`);
        if (wishlistButton) {
          wishlistButton.classList.add('wishlist-button-active');
          wishlistButton.setAttribute('data-added-to-wishlist', 'true');
        }
      });
    });
  }
}
